import React from 'react';
import { GUIDES } from '../guides';

export const formatDate = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });

export const SectionHeading = ({ id, children }) => (
  <h2 id={id} className="mt-12 scroll-mt-24 text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
    {children}
  </h2>
);

export const FaqList = ({ faqs }) => (
  <div className="mt-6 space-y-6">
    {faqs.map((faq) => (
      <div key={faq.question}>
        <h3 className="font-semibold text-gray-900 dark:text-gray-100">{faq.question}</h3>
        <p className="mt-1 text-gray-600 dark:text-gray-400">{faq.answer}</p>
      </div>
    ))}
  </div>
);

export const linkClassName =
  'font-medium text-indigo-700 underline hover:text-indigo-800 dark:text-teal-400 dark:hover:text-teal-300';

// Shared shell for guide/article pages: breadcrumb, H1, updated date, intro
// (the direct answer, first thing crawlers and AI assistants read), the page
// body, links to the other guides and the closing EC Traffic call to action.
const ArticleLayout = ({ path, title, updated, intro, ctaTitle, ctaText, children }) => (
  <main>
    <article className="w-full py-12 md:py-20 lg:py-24 bg-gray-50 dark:bg-gray-950">
      <div className="container px-4 md:px-6 max-w-3xl mx-auto">
        <nav aria-label="Ruta de navegación" className="mb-6 text-sm text-gray-500 dark:text-gray-400">
          <a href="/" className="hover:underline">Inicio</a>
          <span className="mx-2" aria-hidden="true">/</span>
          <span className="text-gray-700 dark:text-gray-300">{title}</span>
        </nav>

        <header className="space-y-4">
          <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900 dark:text-gray-100">
            {title}
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Actualizado el <time dateTime={updated}>{formatDate(updated)}</time> · EC-Compliance
          </p>
          <p className="text-lg text-gray-700 md:text-xl/relaxed dark:text-gray-300">{intro}</p>
        </header>

        {children}

        <SectionHeading id="guias-relacionadas">Guías relacionadas</SectionHeading>
        <ul className="mt-4 space-y-2">
          {GUIDES.filter((guide) => guide.path !== path).map((guide) => (
            <li key={guide.path}>
              <a href={guide.path} className={linkClassName}>{guide.title}</a>
            </li>
          ))}
        </ul>

        <div className="mt-12 flex flex-col items-center gap-4 rounded-lg border border-indigo-200 bg-white p-6 text-center shadow-sm md:p-8 dark:border-indigo-900 dark:bg-gray-900">
          <h2 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100">{ctaTitle}</h2>
          <p className="max-w-xl text-gray-600 dark:text-gray-400">{ctaText}</p>
          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href="/#plataforma"
              className="inline-flex h-10 items-center justify-center rounded-md bg-indigo-700 px-6 text-sm font-medium text-white shadow transition-colors hover:bg-indigo-800 dark:bg-teal-500 dark:text-gray-900 dark:hover:bg-teal-600"
            >
              Conoce EC Traffic
            </a>
            <a
              href="/#contacto"
              className="inline-flex h-10 items-center justify-center rounded-md border border-gray-300 px-6 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
            >
              Solicitar una demostración
            </a>
          </div>
        </div>
      </div>
    </article>
  </main>
);

export default ArticleLayout;
